<template>
  <div class="page dialog-select">
    <header class="two-rows">
      <div>
        <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
        <div class="view-title">{{ 'destination' | lang }}</div>
      </div>
      <div>
        <div>{{ 'DestinationSubtitle' | lang }}</div>
        <div class="floating-label" v-if="!loading && searchOptions.length > 15">
          <input v-model="searchString" placeholder=" " type="text" />
          <label>{{ 'filter' | lang }}</label>
        </div>
      </div>
    </header>
    <div v-if="loading"><div class="flexcentered bigger"><i class="fa fa-fw fa-refresh fa-spin"></i></div></div>
    <div v-scrolleffect v-else>
      <ul class="nav">
        <li v-for="(opt, idx) in showOptions" :key="idx" @click="next(opt)" @keypress.space="next(opt)" tabindex="0" role="button">
          <div class="title">{{opt.Label}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import newProductParameterMixin from '@/mixins/newProductParameterMixin'

export default {
  name: 'NewProductParameterDestinazione',
  mixins: [ page, newProductParameterMixin ],
  computed: {
    what () {
      return 'travels'
    }
  },
  methods: {
    saveParameter (opt) {
      this.buying = { ...this.buying, destination: opt}
      this.buying.ticketInfo.ItemOdTravelsInfo.Travel[0].Destination = { ...opt }
    },
    getData () {
      return this._getDestinations(this.buying.ticketInfo, this.buying.csc ? this.buying.csc.MediaSerialNumber : null, this.buying.csc ? this.buying.csc.MediaUnicity : null)
    }
  }
}
</script>

<style></style>
